module.exports = " <date-fieldtype name=date :data.sync=formData.fields.date :leave-alert=true :config=config></date-fieldtype> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/MetaFields/Date.vue
// module id = 302
// module chunks = 0